(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-review-tabs"] && !Shopify.designMode) return;
  try {
    
  /**
   * 评价标签页的切换逻辑：点击 / 方向键切面板，wai-aria tabs 模式（roving tabindex）。
   * 初始状态由服务端渲染（第一组可见、其余 hidden），这里只接管切换，不做首屏渲染。
   * 另负责 Show more 折叠按钮：切所在容器的 data-expanded；按钮显示与否由当前断点的一行容量决定
   * （1024px 断点与 assets/pdp-review-tabs.css 的折叠媒体查询保持同步）。
   */
  class PdpReviewTabs extends HTMLElement {
    #controller = null;
    #tabs = [];
    #panels = [];
    #desktopQuery = null;

    // 折叠态每个断点保留的张数 = 一行，与 CSS 折叠规则的 nth-child(n+2) / nth-child(n+4) 一一对应
    #rowSize = { desktop: 3, mobile: 1 };

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.#tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.#panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.#tabs.length > 0 && this.#tabs.length === this.#panels.length) {
        this.#tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.#select(index, false), { signal });
          tab.addEventListener('keydown', (event) => this.#onKeydown(event, index), { signal });
        });
      }

      this.#setupShowMore(signal);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    #setupShowMore(signal) {
      this.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('.pdp-rtabs__more');
          if (button) this.#toggleShowMore(button);
        },
        { signal }
      );

      this.#desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.#desktopQuery.addEventListener('change', () => this.#syncShowMoreButtons(), { signal });
      this.#syncShowMoreButtons();
    }

    #toggleShowMore(button) {
      const fold = button.closest('.pdp-rtabs__fold');
      if (!fold) return;

      const expanding = !fold.hasAttribute('data-expanded');
      const anchorBefore = button.getBoundingClientRect().top + window.scrollY;

      fold.toggleAttribute('data-expanded', expanding);

      if (!expanding) {
        // 收起会把按钮上方的卡片抽走，不补滚的话按钮与下方内容整体上移，视口一次跳过一大段
        // （移动端展开 9 张后滚到底部收起尤其明显）。按按钮的实际位移反向滚动，让它留在屏幕
        // 原位、阅读位置不中断；若浏览器的滚动锚定已经自动补过，位移为 0，不会再多滚一次。
        const shift = button.getBoundingClientRect().top + window.scrollY - anchorBefore;
        if (shift < 0) {
          window.scrollBy({ top: shift, behavior: 'instant' });
        }
      }

      button.setAttribute('aria-expanded', expanding ? 'true' : 'false');
      button.textContent = expanding ? button.dataset.less : button.dataset.more;
    }

    #syncShowMoreButtons() {
      const rowSize = this.#desktopQuery?.matches ? this.#rowSize.desktop : this.#rowSize.mobile;

      this.querySelectorAll('.pdp-rtabs__fold').forEach((fold) => {
        const button = fold.querySelector('.pdp-rtabs__more');
        if (!button) return;

        if (fold.querySelectorAll('.pdp-rtabs__card').length <= rowSize) {
          // 一行已放得下全部卡片：回折叠态并藏按钮（断点切换瞬间收缩，不做动画）
          fold.removeAttribute('data-expanded');
          button.hidden = true;
          button.setAttribute('aria-expanded', 'false');
          button.textContent = button.dataset.more;
        } else {
          button.hidden = false;
        }
      });
    }

    #onKeydown(event, index) {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      let target = null;

      if (step) {
        target = (index + step + this.#tabs.length) % this.#tabs.length;
      } else if (event.key === 'Home') {
        target = 0;
      } else if (event.key === 'End') {
        target = this.#tabs.length - 1;
      }

      if (target === null) return;
      event.preventDefault();
      this.#select(target, true);
    }

    #select(index, moveFocus) {
      this.#tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        this.#panels[i].hidden = !selected;
      });

      if (moveFocus) this.#tabs[index].focus();
    }
  }

  if (!customElements.get('pdp-review-tabs')) {
    customElements.define('pdp-review-tabs', PdpReviewTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
